import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useFirebaseApp } from 'reactfire'
import ProductCard from '../molecules/ProductCard'
import 'firebase/firestore'

const Home=(props)=>{
  const [state, setstate] = useState({primarys:[]})
  const [state2, setstate2] = useState({productsGrid:[]})
  const [state3, setstate3] = useState({recomended:[]})
  const firebase=useFirebaseApp()
  const firestore=firebase.firestore()

  useEffect(()=>{
    document.documentElement.scrollTop=0
    firestore.collection('primarys').get().then(querySnapshot=>{
      let primarys=[]
      querySnapshot.forEach((doc)=>{
        primarys.push(doc.data())
      })

      setstate({
        primarys
      })
    })

    firestore.collection('products').where('gallery','==',true).get().then(
      snap=>{
        let productsGrid=[]  
        snap.forEach(doc=>{
          productsGrid.push({id:doc.id,data:doc.data()})
        })
        setstate2({
          productsGrid
        })
      })

    firestore.collection('products').where('recomended','==',true).get().then(
      snap=>{
        let recomended=[]  
        snap.forEach(doc=>{
          recomended.push({id:doc.id,data:doc.data()})
        })
        setstate3({
          recomended
        })
      })

      document.querySelector('.banner-image').classList.add('carged')

      document.querySelector('.banner-text-container').classList.add('carged')
  },[firestore])

  return (
    <main>
      <div className="banner">
        <div className="banner-image">
        <div className="banner-image-container">
          <img src="/logo2.svg" alt="logo-yourstyles"/>
        </div>
        </div>
        <div className="banner-text-container">
          <p>Aprende a conocerte y se tú,<br /> a traves de YOUR STYLE.</p>
          <p>Tienda de ropa y accesorios para todas las edades.</p>
        </div>
      </div>
      <div className="ourProducts">
        <div className="our-text">
          <h2>Nuestros Productos</h2>
        </div>
        <div className="our-cards-container">
        {
            state.primarys &&
            state.primarys.map(p=>(
              <div key={p.name} className="our-card">
                  <img src={p.image} alt={p.name}/>
                  <Link key={p.name} to={`/categorias/${p.category}/${p.subCategory}`}>{p.name}
                  </Link>
              </div>
            ))
          }
        </div>
      </div>
      <div className="gallery">
        <div className="gallery-grid">
        {
            state2.productsGrid &&
            state2.productsGrid.map(p=>(
              <div key={p.id} className="gallery-grid-image">
                <Link to={`/categorias/${p.data.category[0].toLowerCase()}/${p.data.subCategory[0].toLowerCase()}/${p.id}`}>
                  <p>{p.data.name}</p>
                  <img src={p.data.images[0]} alt={p.data.name}/></Link>
              </div>
            ))
          }
        </div>
      </div>
      <div className="recomended">
        <div className="recomended-text">
          <h2>Recomendados</h2>
        </div>
        <div className="recomended-products">
          {
            state3.recomended &&
            state3.recomended.map(r=>(
              <ProductCard key={r.id} product={`${r.data.category[0].toLowerCase()}/${r.data.subCategory[0].toLowerCase()}/${r.id}`} name={r.data.name} price={r.data.price} image={r.data.images[0]} />
            ))
          }
        </div>
      </div>
    </main>
  )
}

export default Home
